import { getLocale, LOCALES, setLocale } from '@/i18n';
import { cn } from '@/lib/cn';

/** RU / EN — переключатель языка интерфейса (смена перезагружает страницу). */
export function LanguageSwitcher({ className }: { className?: string }) {
  const current = getLocale();
  return (
    <div role="radiogroup" aria-label="Language / Язык" className={cn('inline-flex rounded-control bg-surface-2 p-0.5', className)}>
      {LOCALES.map((l) => (
        <button
          key={l.value}
          type="button"
          role="radio"
          aria-checked={current === l.value}
          aria-label={l.label}
          title={l.label}
          onClick={() => setLocale(l.value)}
          className={cn(
            'inline-flex h-7 min-w-9 items-center justify-center rounded-[8px] px-2 text-[12px] font-semibold uppercase transition-colors',
            current === l.value ? 'bg-surface text-fg shadow-card' : 'text-fg-subtle hover:text-fg',
          )}
        >
          {l.value}
        </button>
      ))}
    </div>
  );
}
